import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Additionals} from './additionals';

@Injectable()
export class AdditionalsService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('additionals?' + params.toString()).map((response: Response) => response.json());
    }
    deletePic(_id: string) {
        return this.http.put('org/picture/delete/' + _id,{}).map((response: Response) => response.json());
    }
    deletePic1(_id: string) {
        return this.http.put('org/picture/delete1/' + _id,{}).map((response: Response) => response.json());
    }
    getAllCurrencies() {
        return this.http.get('all/currencies').map((response: Response) => response.json());
    }
    getLogo() {
        return this.http.get('additionals/logo').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('additionals/' + _id).map((response: Response) => response.json());
    }

  getData(fromDate: string,toDate:string) {
    return this.http.get('additionals/getdata?from_date=' + fromDate+'&to_date='+toDate).map((response: Response) => response.json());
  }

    getTrashedById(_id: string) {
        return this.http.get('additionals/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('additionals/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(invoice: Additionals) {
        return this.http.post('additionals', invoice).map((response: Response) => response.json());
    }

    update(invoice: Additionals) {
        return this.http.put('additionals/' + invoice.id, invoice).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('additionals/' + _id).map((response: Response) => response.json());;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/additionals/additionals.service.ts